<template>
    <v-dialog-old ref="dialog" id="serviceSettingsSpecialityDialog">
        <form>
            <fieldset style=" min-width: 1000px">
                <legend>
                    Специальности врача
                </legend>
                <div style="-webkit-column-count:4; -moz-column-count:4; column-count:4;">
                    <label v-for="option in this.dict">
                        <input type="checkbox" v-model="M.checked" :value="option.value"/>
                        <span>{{option.text}}</span>
                    </label>
                </div>
            </fieldset>
            <footer>
                <button class="green" @click.prevent="confirm">Подтвердить</button>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
    export default {
        name: "ServiceSettingsSpecialityDialog",
        props: {
            dict: { type: Array, required: true },
        },
        data() {
            return {
                M: {
                    checked: [],
                },
            }
        },
        methods: {
            confirm() {
                this.$emit('confirm-specialities', this.M.checked);
                this.$refs.dialog.visible = false;
            },
            open(data) {
                this.$refs.dialog.visible = true;
                this.M.checked = data;
            }
        },
    }
</script>

<style lang="scss">
    #serviceSettingsSpecialityDialog {
        width: 70%;
    }
</style>
